import { CreateUserComponent } from './components/create-user/create-user.component';
import { ListUserComponent } from './components/list-user/list-user.component';
import { QuestionaryComponent } from './components/questionary/questionary.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { YourPensionComponent } from './components/your-pension/your-pension.component';
import { AnnuitantDetailsComponent } from './components/annuitant-details/annuitant-details.component';
import { DependantDetailsComponent } from './components/dependant-details/dependant-details.component';
import { ProductChoiceComponent } from './components/product-choice/product-choice.component';
import { YourOptionsQuestionsComponent } from './components/your-options-questions/your-options-questions.component';
import { AfterLoginComponent } from './components/auth/after-login/after-login.component';
import { DependantHealthandlifestyleComponent } from './components/dependant-healthandlifestyle/dependant-healthandlifestyle.component';
import { DependantMedicalConditionsComponent } from './components/dependant-medical-conditions/dependant-medical-conditions.component';
import { YourCedingFundComponent } from './components/your-ceding-fund/your-ceding-fund.component';
import { RegistrationComponent } from 'src/app/pages/user-details/components/registration/registration.component';
import { PostRegistrationComponent } from 'src/app/pages/user-details/components/post-registration/post-registration.component';
import { UnSupportedBrowserComponent } from './components/un-supported-browser/un-supported-browser.component';
import { LogoutComponent } from 'src/app/pages/user-details/components/logout/logout.component';
import { uiCompJsonResolver } from 'src/app/shared/services/api-services/ui.comp.json.resolver';
// import { configDataResolver } from 'src/app/shared/services/api-services/config-data.json.resolver';
import { GuidanceAndAdviceComponent } from './components/guidance-and-advice/guidance-and-advice.component';
import { CMSResolver } from 'src/app/core/resolvers/cms.resolver';
import { authGuard } from '@landg_eap/auth-lib';

const userRoutes: Routes = [
  {
    path: 'get-your-online-quote', // Path is defined in parent
    component: CreateUserComponent,
    data: {
      breadcrumb: 'Create User',
      title: 'Online Quote'
    }
  },
  {
    path: 'you-will-need',
    component: ListUserComponent,
    data: {
      breadcrumb: 'List User',
      title: 'Online Quote - You Will Need'
    }
  },
  {
    path: 'guidance-and-advice',
    component: GuidanceAndAdviceComponent,
    data: {
      breadcrumb: 'Guidance and Advice',
      title: 'Online Quote - Guidance and Advice'
    },
    resolve: { contentData: CMSResolver}
  },
  {
    path: 'before-you-start',
    component: QuestionaryComponent,
    data: {
      breadcrumb: 'Question',
      title: 'Online Quote - Before You Start'
    }
  },



  {
    path: 'your-personal-details',
    component: AnnuitantDetailsComponent,
    data: {
      breadcrumb: 'personalDetails',
      title: 'Online Quote - Annuitant Details'
    }
  },
  // {
  //   path: 'your-pension-savings',
  //   component: YourPensionComponent,
  //   data: {
  //     breadcrumb: 'yourPension'
  //   }
  // },
  {
    path: 'your-dependant',
    component: DependantDetailsComponent,
    data: {
      breadcrumb: 'dependantDetails',
      title: 'Online Quote - Dependant Details'
    }
  },
  {
    path: 'your-product-choice',
    component: ProductChoiceComponent,
    data: {
      breadcrumb: 'productChoice',
      title: 'Online Quote - Products Choice'
    }
  },
  {
    path: 'post-registration/:type',
    component: PostRegistrationComponent,
    pathMatch: 'full'
  },
  {
    path: 'youroptionsquestions',
    component: YourOptionsQuestionsComponent,
    data: {
      breadcrumb: 'Option & Quote',
      title: 'Online Quote - Option & Quote'
    }
  },
  { path: '', redirectTo: 'get-your-online-quote', pathMatch: 'full' },
  {
    path: 'after-login', component: AfterLoginComponent, pathMatch: 'full', canActivate: [authGuard]
  },
  // {
  //   path: 'medical-conditions',
  //   component: MedicalConditionComponent,
  //   data: {
  //     breadcrumb: 'medical-conditions'
  //   }
  // },
  {
    path: 'dependants-lifestyle',
    component: DependantHealthandlifestyleComponent,
    data: {
      breadcrumb: 'dependants-lifestyle',
      title: 'Online Quote - Dependant\'s LifeStyle'
    }
  },
  {
    path: 'dependants-medical-conditions',
    component: DependantMedicalConditionsComponent,
    data: {
      breadcrumb: 'dependant-medical-conditions',
      title: 'Online Quote - Dependant\'s MC'
    }
  },
  {
    path: 'registration',
    component: RegistrationComponent,
    data: {
      title: 'Online Quote - Registration',
      breadcrumb: 'user-registration'
    }

  },
  {
    path: 'update-my-details',
    component: RegistrationComponent,
    data: {
      title: 'Update My Details',
      breadcrumb: 'update-my-details'
    }

  },

  {
    path: 'your-pension-savings',
    component: YourCedingFundComponent,
    data: {
      breadcrumb: 'yourPension',
      title: 'Online Quote - Pension Savings'
    },
    resolve: { uiCompJson: uiCompJsonResolver }
  },
  {
    path: 'un-support/:type', // Path is defined in parent
    component: UnSupportedBrowserComponent,
    pathMatch: 'full'
  },
  {
    path: 'logout',
    component: LogoutComponent,
    pathMatch: 'full'
   
  }

];

@NgModule({
  imports: [
    RouterModule.forChild(userRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [uiCompJsonResolver]
})

export class UserDetailsRouteModule { }
